(function () {
  function initializeConcierge(root) {
    if (root.dataset.kcInitialized === 'true') return;
    root.dataset.kcInitialized = 'true';

    const form = root.querySelector('[data-kc-form]');
    const result = root.querySelector('[data-kc-result]');
    const resultHeading = root.querySelector('[data-kc-result-heading]');
    const selected = root.querySelector('[data-kc-selected]');
    const links = Array.from(root.querySelectorAll('[data-kc-collection]'));
    const products = root.querySelector('[data-kc-products]');
    const productsHeading = root.querySelector('[data-kc-products-heading]');
    const noProduct = root.querySelector('[data-kc-no-product]');
    const restart = root.querySelector('[data-kc-restart]');
    const candidateTemplate = root.querySelector('[data-kc-candidates]');

    if (!form || !result || !candidateTemplate) return;

    function chosenValue(name) {
      return form.querySelector(`input[name="${name}"]:checked`)?.value || '';
    }

    function chosenLabel(name) {
      const input = form.querySelector(`input[name="${name}"]:checked`);
      return input?.closest('label')?.textContent.trim() || '';
    }

    function collectionKeys(audience, usage, material) {
      const keys = [audience];
      if (material !== 'any') return [...keys, material];
      if (usage === 'after_water') keys.push('coton');
      if (usage === 'warmth') keys.push('polaire', 'flanelle');
      if (usage === 'fluid' && audience !== 'enfant') keys.push('kimonos', 'satin');
      if (usage === 'any') keys.push('all');
      return keys;
    }

    function matchingProducts(audience, material) {
      const source = material === 'any' ? 'audience' : 'material';
      const seen = new Set();
      const matches = [];
      const candidates = candidateTemplate.content.querySelectorAll('[data-kc-product-id]');

      for (const candidate of candidates) {
        if (candidate.dataset.kcSource !== source) continue;
        if (candidate.dataset.kcAudience !== audience) continue;
        if (material !== 'any' && candidate.dataset.kcMaterial !== material) continue;
        if (seen.has(candidate.dataset.kcProductId)) continue;
        seen.add(candidate.dataset.kcProductId);
        matches.push(candidate);
        if (matches.length === 3) break;
      }
      return matches;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      const audience = chosenValue('audience');
      const usage = chosenValue('usage');
      const material = chosenValue('material');
      if (!audience || !usage || !material) return;

      selected.textContent = [chosenLabel('audience'), chosenLabel('usage'), chosenLabel('material')].join(' · ');
      const keys = new Set(collectionKeys(audience, usage, material));
      for (const link of links) link.hidden = !keys.has(link.dataset.kcCollection);

      const matches = matchingProducts(audience, material);
      products.replaceChildren(...matches.map((candidate) => candidate.cloneNode(true)));
      productsHeading.hidden = matches.length === 0;
      noProduct.hidden = matches.length !== 0;
      result.hidden = false;
      resultHeading.focus();
    });

    restart.addEventListener('click', function () {
      result.hidden = true;
      form.querySelector('input[name="audience"]')?.focus();
    });
  }

  function initializeAll(scope) {
    if (scope.matches?.('[data-kavieli-concierge]')) initializeConcierge(scope);
    scope.querySelectorAll('[data-kavieli-concierge]').forEach(initializeConcierge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
  } else {
    initializeAll(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
